import { ButtonERP } from "@finanedi.es/storybook"
import {
  faArrowLeft,
  faFilePdf,
  faFloppyDisks,
  faPaperPlane,
} from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { GetImpuestosDtoProps } from "api/DTOs/GetImpuestosDto"
import { useImpuestoEmpresaNew } from "api/ImpuestoEmpresa.hook"
import Modal from "common/components/Modal/Modal"
import {
  getDocumentLabel,
  MODES_DOCUMENTOS,
  TYPES_DOCUMENTOS,
} from "features/Crear/pages/FormCreacionDocumento/constant"
import { FormikDocumentsProps } from "features/Crear/pages/FormCreacionDocumento/CreacionDocumento"
import { AnimatePresence } from "framer-motion"
import { useSelector } from "hooks/useSelector"
import { useCallback } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { globalSelector } from "routes/globalSlice"
import * as ROUTES from "routes/RoutePaths"
import { ArticuloSelectedProps } from "../../../SelectedArticlesDocument/SelectedArticlesDocument"
import FormAsociarDocumento from "../../Forms/AsociarDocumento/AsociarDocumento"

export interface ArticuloReadingSimpleDtoProps {
  cantidad: number
  concepto: string
  id: string
  impuesto: string
  precioVenta: number
  tarifaImpuesto: number
}

const HeaderDocumento = ({
  values,
  setFieldValue,
  handleSubmit,
  isSubmitting,
}: FormikDocumentsProps) => {
  const history = useHistory()
  const { t } = useTranslation()
  const { formasPago } = useSelector(globalSelector)

  const { impuestoEmpresa } = useImpuestoEmpresaNew({
    EmpresaId: values?.empresaActiva?.id,
    TipoImpuestoEmpresa:
      values?.documentoType?.mode === MODES_DOCUMENTOS.VENTA ? 1 : 0,
    EsActivo: true,
    IsPagingEnabled: false,
  })

  const recalculateTotal = useCallback(
    (updatedConceptos?: ArticuloSelectedProps[]) => {
      const totalValue = updatedConceptos?.reduce(
        (total: number, concepto: ArticuloSelectedProps) => {
          return total + concepto.cantidad * concepto.precioVenta
        },
        0
      )
      const cantidadValue = updatedConceptos?.reduce(
        (total: number, concepto: ArticuloSelectedProps) => {
          return total + concepto.cantidad
        },
        0
      )

      setFieldValue("total", totalValue)
      setFieldValue("cantidadTotalArticulos", cantidadValue)
    },
    [setFieldValue]
  )

  const handleAddArticle = useCallback(
    (newArticulos?: ArticuloReadingSimpleDtoProps[]) => {
      const updatedConceptos = newArticulos?.map(
        (evento: ArticuloReadingSimpleDtoProps, index: number) => {
          // @ts-expect-error TS(2322): Type 'GetAllImpuestosDtoProps | undefined' is not ...
          const userTaxeSelected: GetImpuestosDtoProps | undefined =
            impuestoEmpresa?.items?.find(
              // @ts-expect-error TS(2769): No overload matches this call.
              ({ tipo, valor }: GetImpuestosDtoProps) =>
                (tipo ===
                  (values.documentoType.mode === MODES_DOCUMENTOS.VENTA
                    ? 1
                    : 0) &&
                  valor === parseInt(evento?.impuesto, 10)) ||
                (tipo ===
                  (values.documentoType.mode === MODES_DOCUMENTOS.VENTA
                    ? 1
                    : 0) &&
                  valor === 21)
            )

          return {
            ...evento,
            cantidad: evento.cantidad,
            precioVenta: evento.precioVenta,
            impuestoArticuloTipoId: userTaxeSelected?.id,
            impuestoNombre: userTaxeSelected?.nombre,
            impuestoArticuloPorcentaje: userTaxeSelected?.valor,
            total: evento.precioVenta * evento.cantidad,
            cuentaContableId: values.cuentaContableId ?? null,
            index: values.conceptos.length + index + 1,
          }
        }
      )

      setFieldValue("conceptos", updatedConceptos)
      recalculateTotal(updatedConceptos)
    },
    [
      setFieldValue,
      recalculateTotal,
      impuestoEmpresa?.items,
      values.cuentaContableId,
      values.conceptos.length,
      values.documentoType.mode,
    ]
  )

  return (
    <div className='tw-w-full tw-flex tw-justify-between tw-items-center tw-h-auto md:tw-h-[72px] tw-bg-simple-10 tw-shadow tw-px-4'>
      <div className='tw-flex tw-flex-row tw-w-fit'>
        <ButtonERP
          onClick={() => {
            values.documentoType.type === TYPES_DOCUMENTOS.FACTURA_RECTIFICATIVA
              ? history.goBack(ROUTES.FACTURAS)
              : values.config.haveArticles
              ? setFieldValue("documentoType.screen", 2)
              : history.goBack()
          }}
          icon={<FontAwesomeIcon icon={faArrowLeft} />}
          customize={{
            type: "transparent",
            size: "md",
          }}
        />
        <div className='tw-flex tw-flex-row tw-items-center tw-h-10 tw-font-medium tw-text-lg tw-ml-6'>
          {values.modoEditarBorrador
            ? `${t("crear.documento.editDraftLabel")}`
            : `${t("crear.documento.create")} ${getDocumentLabel(
                values.documentoType.type,
                t
              )}`}
        </div>
      </div>
      <div className='tw-flex tw-flex-col md:tw-flex-row tw-h-auto md:tw-h-10 tw-items-end md:tw-items-center tw-my-2 md:tw-my-0 tw-gap-3'>
        {values.documentoType.type !== TYPES_DOCUMENTOS.PRESUPUESTO &&
          values.documentoType.type !== TYPES_DOCUMENTOS.PROFORMA && (
            <ButtonERP
              disabled={!values?.librado?.id}
              onClick={() => {
                setFieldValue(
                  "modals.showModalAsociarDoc",
                  !values.modals.showModalAsociarDoc
                )
              }}
              customize={{
                type: "white",
                size: "md",
              }}
              label={`${t("newDoc.pedido.associateDocLabel")}`}
            />
          )}

        {values.documentoType.type !== TYPES_DOCUMENTOS.PROFORMA && (
          <ButtonERP
            onClick={() => {
              setFieldValue("config.modeSubmitNormal", false)
              handleSubmit && handleSubmit()
            }}
            disabled={
              !(
                values?.librado?.id &&
                values?.librador?.id &&
                values?.conceptos?.length
              )
            }
            loading={isSubmitting && !values.config.modeSubmitNormal}
            icon={<FontAwesomeIcon icon={faFilePdf} />}
            customize={{
              type: "white",
              size: "md",
            }}
            label={`${t("crear.documento.vistaPrevia")}`}
          />
        )}
        {values.documentoType.type === TYPES_DOCUMENTOS.FACTURA && (
          <ButtonERP
            icon={<FontAwesomeIcon icon={faFloppyDisks} />}
            loading={
              isSubmitting &&
              values.config.modeSubmitNormal &&
              values.esBorrador
            }
            disabled={
              !(
                values?.librado?.id &&
                values?.librador?.id &&
                values?.conceptos?.length
              )
            }
            onClick={() => {
              if (values.modoEditarBorrador) {
                setFieldValue("config.modeSubmitNormal", true)
                return handleSubmit && handleSubmit()
              }
              setFieldValue("esBorrador", true)
              setFieldValue("config.modeSubmitNormal", true)
              handleSubmit && handleSubmit()
            }}
            customize={{
              type: "primary",
              size: "md",
            }}
            label={
              values?.modoEditarBorrador
                ? `${t("crear.documento.editDraftLabel")}`
                : `${t("crear.documento.saveInvoiceDraft")}`
            }
          />
        )}
        <ButtonERP
          icon={<FontAwesomeIcon icon={faPaperPlane} />}
          loading={
            isSubmitting && values.config.modeSubmitNormal && !values.esBorrador
          }
          disabled={
            !(
              values?.librado?.id &&
              values?.librador?.id &&
              values?.conceptos?.length &&
              (values.documentoType.type !== TYPES_DOCUMENTOS.PROFORMA ||
                values.numeroDocumento)
            )
          }
          onClick={() => {
            if (values.modoEditarBorrador) {
              setFieldValue("esBorrador", false)
              return handleSubmit && handleSubmit()
            }
            if (
              values.documentoType.type !==
              TYPES_DOCUMENTOS.FACTURA_RECTIFICATIVA
            ) {
              setFieldValue("config.modeSubmitNormal", true)
              handleSubmit && handleSubmit()
            } else {
              setFieldValue("modals.showModalSubmitRectificativa", true)
            }
          }}
          customize={{
            type: "secondary",
            size: "md",
          }}
          label={
            values.documentoType.type === TYPES_DOCUMENTOS.PROFORMA
              ? `${t("newDoc.facturaProforma.create")}`
              : `${t("crear.documento.emitLabel")} ${getDocumentLabel(
                  values.documentoType.type,
                  t
                )}`
          }
        />
      </div>
      <AnimatePresence>
        {values.librador && values.librado && (
          <Modal
            showHeader={false}
            size='extra-big'
            maskClassName='!tw-z-40 !tw-rounded'
            onHide={() => setFieldValue("modals.showModalAsociarDoc", false)}
            visible={values.modals.showModalAsociarDoc}
          >
            <FormAsociarDocumento
              librador={
                values.librado.empresaId ?? values.librador.empresaContactoId
              }
              librado={
                values.librado.empresaContactoId ?? values.librador.empresaId
              }
              isVenta={values.documentoType.mode === MODES_DOCUMENTOS.VENTA}
              type={values.documentoType.type}
              handleAddArticle={handleAddArticle}
              valuesForm={values}
              handleVariable={setFieldValue}
              formasPago={formasPago}
              onHide={() => setFieldValue("modals.showModalAsociarDoc", false)}
              data={values.config.modalAsociar}
            />
          </Modal>
        )}
      </AnimatePresence>
    </div>
  )
}

export default HeaderDocumento
